"use client";

import classNames from "classnames";
import { forwardRef } from "react";

import styles from "./typography.module.scss";
import { TypographyProps } from "./typography.types";

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  (
    {
      as = "p",
      color = "white",
      align = "left",
      bold = false,
      semi = false,
      italic = false,
      variant,
      children,
      className,
      ...restProps
    },
    ref
  ) => {
    const Element = as;

    return (
      <Element
        {...restProps}
        ref={ref}
        style={{ textAlign: align }}
        className={classNames(
          styles[variant],
          styles[color],
          styles.typography,
          italic && styles.italicTypo,
          bold && styles[`${variant}--bold`],
          semi && styles[`${variant}--bold`],
          className
        )}
      >
        {children}
      </Element>
    );
  }
);

Typography.displayName = "Typography";

export { Typography };
